import { AuthError, defineEntity } from '@juvare/platform-app/App';
import { onAuthGet, onAuthImport, onAuthList, onAuthMassUpdate, onAuthPost, onChangeSync, onChangedAsync, onImportRow, onMigrate, onTransform, } from './callbacks';
import { onMassUpdateTransform } from './callbacks/onMassUpdateTransform';
import { onScheduleChangedAsync } from './callbacks/onScheduleChangedAsync';
import { fileColumns } from './types';
export const fileEntityName = 'documentLibraryFile';
export const defineDocumentLibraryFileEntity = (config, features) => defineEntity({
    version: 15,
    columns: fileColumns,
    onMigrate: onMigrate,
    onTransform: (context, params) => onTransform(context, params),
    onAuthMassUpdate,
    onMassUpdateTransform: onMassUpdateTransform,
    onChangeSync,
    onScheduleChangedAsync,
    onChangedAsync: (context, params) => onChangedAsync(context, params, config, features),
    onAuthGet: (appState, userState, response, context) => onAuthGet(appState, userState, response, config, context, features),
    onAuthList: onAuthList,
    onAuthPost: (appState, userState, params, context) => onAuthPost(appState, userState, params, config, context, features),
    onAuthAttachment: () => {
        throw new AuthError('Unauthorized');
    },
    onAuthImport: (_appState, userState, _params, context) => onAuthImport(userState, context, features),
    onImportRow: (context, row) => onImportRow(config, context, features, row),
});
